import { BADGES_CONFIG } from '@config/badges.config'
import { Compass, Crown, Lightbulb, Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface UserBadgeProps {
  totalLikes: number
  showTooltip?: boolean
  size?: number
}

const UserBadge = ({ totalLikes, showTooltip = true, size = 20 }: UserBadgeProps) => {
  const { t } = useTranslation()
  const currentBadge = BADGES_CONFIG.levels
    .slice()
    .reverse()
    .find((level) => totalLikes >= level.minLikes)

  if (!currentBadge) return null

  const BadgeIcon = {
    Sparkles,
    Compass,
    Lightbulb,
    Crown,
  }[currentBadge.icon] as React.ElementType

  return (
    <div className="relative group">
      {BadgeIcon && (
        <BadgeIcon size={size} className={`${currentBadge.color} transition-transform group-hover:scale-110`} />
      )}
      {showTooltip && (
        <div className="absolute -bottom-[25px] left-[170px] transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50">
          {t(currentBadge.tooltip)}
          <div className="text-[10px] opacity-80">{t(currentBadge.description)}</div>
        </div>
      )}
    </div>
  )
}
export default UserBadge
